import LiveDataProvider from "./LiveDataProvider";
import FavoriteTournamentsProvider from "../common/favorite-tournaments/FavoriteTournamentsProvider";
import Outlet from "../router/Outlet";

export default function Live() {
    return (
        <LiveDataProvider>
            <FavoriteTournamentsProvider>
                <Outlet />
            </FavoriteTournamentsProvider>
        </LiveDataProvider>
    );
}
